module.exports = __webpack_public_path__ + "img/组 3.2971e230.webp";